import React, { ReactNode } from "react";
import { MenuItem, MenuItemProps } from "@mui/material";
import { getTranslation } from "./components/TranslationWrapper/TranslationWrapper";

/**
 * Convert een object naar JSX object MenuItems
 * @param obj
 * @param classes
 * @return {*}
 */
export function convertObjectToSelectOptions(
  obj: { [k in string]: { value: string | number; label: string; transKey: string; disabled?: boolean } },
  classes?: { [k in string]: string }
) {
  return Object.keys(obj).map((objKey) => {
    let label = obj[objKey].label;

    if (obj[objKey].transKey !== undefined) {
      label = getTranslation("global" + "." + obj[objKey].transKey, obj[objKey].label);
    }

    return (
      <MenuItem
        classes={
          classes
            ? {
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }
            : undefined
        }
        disabled={obj[objKey].disabled}
        key={obj[objKey].transKey}
        value={obj[objKey].value}
      >
        {label}
      </MenuItem>
    );
  });
}

/**
 * Convert een array naar een JSX object MenuItems
 * @param arr
 * @param classes
 * @returns {*}
 */
export function convertArrayToSelectOptions(
  arr: { value: string | number; label: string; transKey: string; id?: string | number }[],
  classes?: { [k in string]: string },
  itemProps?: (MenuItemProps & { label?: ReactNode })[]
) {
  return arr.map((prop, i) => {
    let label = prop.label;

    if (prop.transKey != null) {
      label = getTranslation("global" + "." + prop.transKey, prop.label);
    }

    return (
      <MenuItem
        classes={
          classes
            ? {
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }
            : undefined
        }
        key={prop.transKey}
        value={prop.value ?? prop.id}
        {...(itemProps?.[i] ?? {})}
      >
        {itemProps?.[i].label ?? label}
      </MenuItem>
    );
  });
}
